export enum ScheduleVariant {
  WITHOUT_ADDITIONAL_PAYMENT = 0,
  WITH_ADDITIONAL_PAYMENT_REDUCED_INSTALLMENT = 1,
  WITH_ADDITIONAL_PAYMENT_SHORTENED_PERIOD = 2,
}
